import React from 'react';
import vsLeft from '@/imgs/AnalysisSpecComp/vs-left.png';
import vsRight from '@/imgs/AnalysisSpecComp/vs-right.png';
import vs from '@/imgs/AnalysisSpecComp/vs.png';
// interface ProductComparisonProps {
//   className?: string;
// }

const ProductComparison: React.FC<any> = ({ className = '', totalData }) => {
  return (
    <div
      className={`mb-3 rounded-lg ${className}`}
      style={{ background: 'linear-gradient(267deg, #F2F3FF 4.19%, #F6F7FF 86.14%)' }}
    >
      {/* 标题 */}
      <h2
        className="pt-2 text-sm font-semibold text-[#1F1F1F]"
        style={{
          background: 'linear-gradient(270deg, #5D2BC7 0%, #A644CA 100%)',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}
      >
        基金产品深度 对比分析专业对比
      </h2>
      {/* 产品对比卡片容器 */}
      <div className="flex items-center justify-center pb-3 pt-2">
        {/* 产品1 - 招商中证新能源汽车ETF联接A */}
        <div
          className="relative h-[49px] w-[150px] bg-contain bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${vsLeft})` }}
        >
          {/* 产品名称 */}
          <div className="relative z-10 flex h-full items-center p-4">
            <span className="text-xs font-semibold leading-tight text-[#5959EB]">
              {totalData.product_info &&
                totalData.product_info[0] &&
                totalData.product_info[0].产品名称}
            </span>
          </div>
        </div>

        {/* 对比图标 */}
        <div className="relative mx-[10px] flex h-[51px] w-[36px] items-center justify-center">
          <img src={vs} alt="vs" className="h-full w-full object-cover" />
        </div>

        {/* 产品2 - 易方达消费行业股票 */}
        <div
          className="relative h-[49px] w-[109px] bg-contain bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${vsRight})` }}
        >
          {/* 产品名称 */}
          <div className="relative z-10 flex h-full items-center p-4">
            <span className="text-xs font-semibold leading-tight text-[#FA8C16]">
              {totalData.product_info &&
                totalData.product_info[1] &&
                totalData.product_info[1].产品名称}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductComparison;
